// extracted by mini-css-extract-plugin
export default {"text":"marginText_text__-DrvY","symbol":"marginText_symbol__j7UPa"};